import { Mutations, Actions, Module, Getters } from 'vuex-smart-module'

import { SupportService } from '@/api'

export class SupportState {
  phone = ''
}

export class SupportGetters extends Getters<SupportState> {}

export class SupportMutations extends Mutations<SupportState> {
  setPhone(phone: string) {
    this.state.phone = phone
  }
}

export class SupportActions extends Actions<SupportState, SupportGetters, SupportMutations> {
  async getPhone() {
    const result = await SupportService.getSupportPhone()
    if (result) {
      this.mutations.setPhone(result.phone)
    }
  }
}

export const support = new Module({
  state: SupportState,
  getters: SupportGetters,
  mutations: SupportMutations,
  actions: SupportActions,
})
